import React from 'react';
import axios from '../../axios';
import ModalAlert from '../../redux/components/modal/modal_alert';
import ModalLoader from '../../modal/modal_loader';

const Main = ({ productsCarts, setProductsCarts, company, companies_user }) => {
  const modalLoaderRef = React.useRef(null);
  const modalAlertDeleteSuccessRef = React.useRef(null);
  const modalAlertErrorRef = React.useRef(null);
  const [modalAlertError, setModalAlertError] = React.useState(
    '失敗しました。時間をおいてもう一度やり直してください。'
  );
  const calculateTotal = productsCarts.reduce(
    (sum, productsCart) =>
      sum + productsCart.product.price * productsCart.quantity,
    0
  );
  const [totalAmount, setTotalAmount] = React.useState(calculateTotal);

  const removeProductCart = React.useCallback((productsCartId, index) => {
    axios
      .post(`/api/community/products_carts/remove`, {
        id: productsCartId
      })
      .then(() => {
        setProductsCarts(prev => {
          const newProductsCart = [...prev];
          newProductsCart.splice(index, 1);
          return newProductsCart;
        });
      });
    setTotalAmount(
      totalAmount -
        productsCarts[index].product.price * productsCarts[index].quantity
    );
  });

  const toConfirmationPage = React.useCallback(() => {
    window.location.href =
      `/community/${company.id_to_param}${companies_user ? '/products_carts/confirmation' : '/invite'}`;
  }, []);

  const toTopPage = React.useCallback(() => {
    window.location.href = '/community/' + company.id_to_param;
  }, []);

  return (
    <div>
      {productsCarts.length > 0 ? (
        <div className="mx-auto container row justify-content-between m-0 p-0">
          <div className="col-lg-8 col-xs-12">
            <div className="block-content pt-2 px-2">
              <div className="container">
                {productsCarts.map((productsCart, index) => (
                  <ProductsCartsBox
                    key={productsCart.id}
                    productsCart={productsCart}
                    setProductsCarts={plan => {
                      setProductsCarts(prev => {
                        const newproductsCarts = [...prev];
                        newproductsCarts[index] = plan;
                        return newproductsCarts;
                      });
                    }}
                    removeProductCart={() => {
                      removeProductCart(productsCart.id, index);
                    }}
                    totalAmount={totalAmount}
                    setTotalAmount={setTotalAmount}
                  />
                ))}
                <ModalAlert
                  ref={modalAlertDeleteSuccessRef}
                  id="modalAlertDraftSuccess"
                  title="削除完了"
                  content="買い物かごを削除しました。"
                  approveFunc={() => toTopPage()}
                />
                <ModalAlert
                  ref={modalAlertErrorRef}
                  id="modalAlertError"
                  title="削除失敗"
                  content={modalAlertError}
                  approveFunc={() =>
                    setTimeout(
                      () =>
                        setModalAlertError(
                          '買い物かごの削除に失敗しました。時間をおいてもう一度やり直してください。'
                        ),
                      1000
                    )
                  }
                />
                <ModalLoader ref={modalLoaderRef} />
              </div>
            </div>
          </div>
          <div className="bg-yellow border col-lg-3 col-xs-12">
            <div className="block-content pt-5 px-2">
              <div className="text-center mt-4">
                <button
                  type="button"
                  className="bg-black w-100 pb-2_5 pt-2_5 black-button"
                  style={{ border: 'solid 1px #000', color: '#fff' }}
                  value="submit_button_for_product"
                  onClick={toConfirmationPage}
                >
                  ご注文手続きへ
                </button>
              </div>
              <div className="">
                <button
                  type="button"
                  className="bg-graydark1 w-100 pb-2_5 pt-2_5 mt-3"
                  style={{ border: 'solid 1px #bfbfbf', color: '#fff' }}
                  value="submit_button_for_product"
                  onClick={toTopPage}
                >
                  お買い物を続ける
                </button>
              </div>
              <div className="text-center mt-3">
                <p className="text-fz-12px">
                  ご注文小計:{' '}
                  <span className="text-fz-22px text-price">
                    ￥ {totalAmount.toLocaleString()} (税込)
                  </span>
                </p>
                <p className="text-fz-10px">送料が別途かかります。</p>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="block block-rounded">
          <div className="block-content pt-5 px-2">
            <div className="container">
              <div className="text-center pb-4">
                <img
                  src="/img/shopping_cart.svg"
                  className="mb-4"
                  height="auto"
                  style={{ width: '40px' }}
                />
                <p className="text-fw-500 text-black-666">
                  商品が買い物かごにありません。
                </p>
                <span className="text-fw-normal text-black-999 text-fz-14px">
                  コミュニティTOPページからアイテムを購入しましょう!
                </span>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const ProductsCartsBox = ({
  productsCart,
  setProductsCarts,
  removeProductCart,
  totalAmount,
  setTotalAmount
}) => {
  const updateProductsCarts = React.useCallback(
    () => {
      axios.post(
        `/api/community/products_carts/update/${productsCart.id}`,
        productsCart
      );
    },
    [productsCart]
  );

  const first_image_url = productsCart.product.products_images[0]
    ? productsCart.product.products_images[0].image_url_medium
    : '';

  const numOfRecentStock = React.useMemo(
    () => {
      var array = [];
      var maxNumber =
        productsCart.products_detail.recent_stock > 30
          ? 30
          : productsCart.products_detail.recent_stock;
      for (var i = 1; i <= maxNumber; i++) {
        array.push(i);
      }
      return array.map(i => (
        <option value={i} key={i}>
          {i}
        </option>
      ));
    },
    [productsCart]
  );

  return (
    <div className="py-4">
      <div className="border-bottom row align-items-center pb-4">
        <div className="col-2 p-1">
          <img className="w-100" src={first_image_url} />
        </div>
        <div className="col-lg-8 col-7">
          <div className="p-1">
            <p className="">{productsCart.product.title}</p>
            {productsCart.products_detail.type && (
              <p className="">
                {productsCart.products_detail.type}:{' '}
                {productsCart.products_detail.name}
              </p>
            )}
          </div>
          <div className="p-1 row align-items-center">
            <p className="mb-0 col-lg-4 col-8 pr-0">
              個数:
              <select
                id="capacity"
                className="pl-1 p-0 textarea--eventreport form-select"
                onBlur={updateProductsCarts}
                onChange={e => {
                  setProductsCarts({
                    ...productsCart,
                    quantity: Number(e.target.value)
                  });
                  setTotalAmount(
                    totalAmount +
                      (Number(e.target.value) - productsCart.quantity) *
                        productsCart.product.price
                  );
                }}
                defaultValue={productsCart.quantity || ''}
              >
                {numOfRecentStock}
              </select>
            </p>
            <button
              className="bg-white border-none p-0"
              onClick={() => removeProductCart()}
            >
              <p className="text-fz-14px text-black-333 text-fw-normal m-1 ml-4">
                削除
              </p>
            </button>
          </div>
        </div>
        <div className="col-lg-2 col-3 p-1">
          <p className="">
            ￥{' '}
            {productsCart.product.price
              ? productsCart.product.price.toLocaleString()
              : 0}
          </p>
        </div>
      </div>
    </div>
  );
};

export default Main;
